import { SanityImageGridBlock } from '../../types/generated/graphql-types'
import { ImageGridItem, ImageGridProps } from '../components/blocks/ImageGrid'
import { notEmpty } from '../utilities/filters'
import { validImage } from '../utilities/imageFilters'
import { Presets } from '../utilities/imagePreset'
import { getImageProps } from '../utilities/imagePropUtils'
import { mapSanityLinkToInternalExternalLink } from './LinkMapper'

export const sanityImageGridToImageGridProps = ({
  heading,
  subHeading,
  items,
}: SanityImageGridBlock): ImageGridProps => ({
  heading: heading ?? undefined,
  subHeading: subHeading ?? undefined,
  items:
    items?.filter(notEmpty).map(
      item =>
        ({
          image: validImage(item?.image)
            ? getImageProps(item.image, Presets.imageGrid)
            : undefined,
          link: item.link
            ? mapSanityLinkToInternalExternalLink(item.link)
            : {
                url: '',
                title: '',
              },
        } as ImageGridItem)
    ) ?? ([] as ImageGridItem[]),
})
